<template>
  <div class="reporting-hierarchy-cell-renderer">
    <div class="hierarchy-name">
      <template v-if="hierarchyName.type === 'text'">
        {{ hierarchyName.text }}
      </template>
      <template v-else-if="hierarchyName.type === 'link'">
        <span class="workpackage-link-container">
          <span>{{ hierarchyName.text }}</span>
          <a
            class="workpackage-link"
            :href="`/pricing/desk-view/workpackage/${hierarchyName.linkData.wpId}`"
            target="_blank"
            :title="
              $t('reporting.config.openWorkpackage', {
                name: hierarchyName.linkData.wpName || hierarchyName.linkData.wpId,
              })
            "
          >
            <span>{{ hierarchyName.linkData.wpName || hierarchyName.linkData.wpId }}</span>
            <i class="mdi mdi-open-in-new" />
          </a>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import featureFlagsMixin from '../../../mixins/featureFlags';
import { reportingWorkpackageLinkLevel } from '@enums/feature-flags';

export default {
  name: 'ReportingHierarchyCellRenderer',

  mixins: [featureFlagsMixin],

  computed: {
    hierarchyName() {
      const data = get(this.params, 'data');
      if (!data) {
        return { type: 'text', text: '' };
      }

      // For store group rows and attribute rows - don't show name in hierarchy column (shown in controls column instead)
      if (data.isStoreGroupRow || data.isAttributeRow) {
        return {
          type: 'text',
          text: '',
        };
      }

      const { name, level, workpackageIdForNode, workpackageNameForNode } = data;

      // Get the configured level for workpackage links from feature flag
      // 2 = Category level, 3 = Pricing Group level
      const workpackageLinkLevel = this.toggleLogic[reportingWorkpackageLinkLevel];

      // Show workpackage links at the configured level
      // Backend provides workpackageIdForNode and workpackageNameForNode
      // Only show link to the workpackage that owns this node's data
      if (level === workpackageLinkLevel && workpackageIdForNode) {
        return {
          type: 'link',
          text: name,
          linkData: {
            wpId: workpackageIdForNode,
            wpName: workpackageNameForNode,
          },
        };
      }

      // For all other levels, just return the name as text
      return {
        type: 'text',
        text: name || '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.reporting-hierarchy-cell-renderer {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 8px;
  height: 40px;
}

.hierarchy-name {
  flex: 1;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
